import { deserializeList } from "../crm/api";

// Active branch staff, matching TasksController::STAFF_ROLES.
const ASSIGNABLE_ROLES = ["superadmin", "admin", "manager", "user"];

// Both the legacy HTTP response and card sections contain the complete body.
export function normalizeTasks(body) {
  const doc = body || {};
  return { items: deserializeList(doc), meta: doc.meta || {} };
}

export function normalizeTaskUsers(body) {
  return (body || [])
    .filter((u) => u.active !== false && ASSIGNABLE_ROLES.includes(u.role))
    .map((u) => ({ id: u.id, name: u.name || u.email || `#${u.id}` }));
}
